<template>
  <div class="SubscriptionPaymentDetail">
    <transition name="fade" mode="out-in" v-if="isLoading">
      <app-loading
        class="fullscreen"
        :is-loading="isLoading"
        :spinner-color="'#1474a4'"
      />
    </transition>
    <template v-else>
      <template>
        <section class="SubscriptionPurchase_body SubscriptionPurchase_body-selectPaymentMethod SubscriptionPaymentDetail_body">
          <div class="container">
            <div class="wrapper-top">
              <h2 class="title">
                {{ $t('subscription_purchase.paymentMethod.title', 'Payment method') }}
              </h2>
            </div>

            <payment-methods
              :sbeflag = {sbeflag}
              :payment-method-submit-active="false"
              @payment-method-selected="setPaymentMethod($event)"
            >
              <p slot="payment-footer">
                {{ $t('myaccount.paymentDetails.notificationForMethodChange', 'Please note that the payment method and details you use for this payment will be used for future recurring payments. You can change your payment method and details at any time in the "Payment Details" section in your Account.') }}
              </p>
            </payment-methods>
         <div id="payment-page">
          <div class="container">
           <div class="payment-container demo">
             <div id="dropin-container">
            </div>
          </div>
        </div>
       </div>
          </div>
        </section>

        <section class="SubscriptionPurchase_footer SubscriptionPurchase_footer-selectPaymentMethod">
          <div class="container">
            <app-button
              type="submit"
              @click.prevent="payNowWithChangePaymentMethodTask.run()"
              :is-loading="taskIsActive"
              data-name="SubscriptionPurchase-submitButton"
              :disabled="taskIsActive || !paymentMethodCode"
              v-if= !taskIsActive
            >
              {{ $t('subscription_buynow.paymentDetail.button', 'Pay now') }} ›
            </app-button>
      <!-- <div>
        <br>
        <div id="payment-page">
         <div class="container">
           <div class="payment-container demo">
             <div id="dropin-container">
            </div>
          </div>
        </div>
       </div>
      </div> -->

            <!-- <p class="tips-security">
              {{ $t('checkout.payment.secureType', 'You will be redirected to a secure checkout page.') }}
            </p> -->

            <div ref="paymentForm" v-html="paymentForm" v-show="false"></div>

            <!-- <template v-if="currentCountryCode === 'GB' && sbeCompliance !== 'True' || currentCountryCode === 'NL' && sbeCompliance !== 'True' || currentCountryCode === 'DE' && sbeCompliance !== 'True'">
            <app-modal  name="sbecompliancemodal" :clickToClose="false" width="500px">
            <div class="v--modal-content">
              <div class="newFlowForCancelReplenishment_popUp" >
                <div class="sbeTC" v-html="$t('checkout.noPayment.button.decline.sbeterms')"> </div>
                 <div class="modal-button-wrapper"> 

                   <app-button
                      data-name="AcceptDue" 
                       @click="Acceptpaymentdue"
                        class="AppButton" >
                     {{ $t('checkout.noPayment.button.confirmOrder.sbe', 'Confirm') }}
                   </app-button>
                </div> 
              </div>
            </div>
            </app-modal> 
            </template> -->
          </div>
        </section>
      </template>
    </template>
  </div>
</template>

<script>
  import Vue from 'vue'
  import PaymentGeneralMixin from 'mixins/payment-general'
  import { extractErrorMessage } from '@/utilities/common'
  import { detectedCulture } from 'utilities/common/culture'
  import { mapState } from 'vuex' 
  import AdyenCheckout from '@adyen/adyen-web';
  import '@adyen/adyen-web/dist/adyen.css'; 

  export default {
    name: 'subscription-payment-detail',
    mixins: [PaymentGeneralMixin],
    data () {
      return {
        isAgree: false,
        isLoading: false,
        termsAndCconditions: this.$t('common.purchase.termsAndConditions'),
        cancelPaymentUrl: window.location.href,
        currentCountryCode: detectedCulture.countryCode,
        sbeflag:'NA'
      }
    },

    computed: {
        ...mapState('account', { 
        sbeCompliance: state => state.profile.personalDetail.sbeCompliance
       }), 
    }, 

    tasks (t) {
      return {
        payNowWithChangePaymentMethodTask: t(async function () {
          this.taskIsActive = true
          let provider = this.paymentMethodCode.split('.')[0]
          if (provider === 'Adyen') {
          await Vue.api.account.payNowWithChangePaymentMethod(this.paymentMethodCode, this.$router.currentRoute.params.id, this.cancelPaymentUrl,this.sbeCompliance).then(data => {
          localStorage.setItem('ordernumber', data.orderNumber);
         }).catch((error) => {
        this.$notify({
          type: 'error',
          title: extractErrorMessage(error)
        })
      })
        await Vue.api.account.adyenpastduepayment(provider, this.sbeCompliance, this.$router.currentRoute.params.id, window.localStorage.getItem('ordernumber'), this.paymentMethodCode).then(data => {
        localStorage.setItem('sessionID', data.id);
        localStorage.setItem('sessiondata', data.session);
        localStorage.setItem('Client', data.clientKey);
        localStorage.setItem('Env', data.environment);
       
      }).catch((error) => {
        this.$notify({
          type: 'error',
          title: extractErrorMessage(error)
        })
      })
   let brandcode =  this.paymentMethodCode.split('.')[1]
   const cardConfiguration = {
   hasHolderName: true,
   holderNameRequired: true,
   brands:[brandcode],
   
};
  const configuration = {
  environment: window.localStorage.getItem('Env'),
  clientKey: window.localStorage.getItem('Client'),
  showPayButton: true,
  analytics: {
    enabled: true 
  },
  session: {
    id: window.localStorage.getItem('sessionID'), 
    sessionData: window.localStorage.getItem('sessiondata'),
   
  },
  onPaymentCompleted: (result, component) => {

   if(result.resultCode === 'Authorised'){

     Vue.prototype.$notify({
                type: 'success',
                title: Vue.prototype.$t('popuptips.paymentMethod.payNow.successful', 'Your payment past due paided successfully'),
                duration: 5000
              })
              window.location.href = `${window.location.origin}/${this.$router.options.base}/pay-now-successful`
        
            } else {
              Vue.prototype.$notify({
                type: 'error',
                title: Vue.prototype.$t('popuptips.paymentMethod.payNow.failed', 'Your payment past due paided failed'),
                duration: 5000
              })
              window.location.href = `${window.location.origin}/${this.$router.options.base}/subscription-error`

   }
      console.info(result, component);
  },
  onError: (error, component) => {
      console.error(error.name, error.message, error.stack, component);
  },
 
  paymentMethodsConfiguration: {
    card: cardConfiguration
  }
};

// Create an instance of AdyenCheckout using the configuration object.
const checkout = await AdyenCheckout(configuration);

// Create an instance of Drop-in and mount it to the container you created.
const dropinComponent = checkout.create('dropin').mount('#dropin-container');

           
      // window.location.href = `${window.location.origin}/${this.$router.options.base}/pastdue-adyenpayment`
          }
 
      else {
          const { htmlForm } = await Vue.api.account.payNowWithChangePaymentMethod(this.paymentMethodCode, this.$router.currentRoute.params.id, this.cancelPaymentUrl,this.sbeCompliance)
          this.paymentForm = htmlForm
      }
        }).onError(function (task) {
          this.$notify({
            type: 'error',
            title: extractErrorMessage(task.error)
          })
          this.taskIsActive = false
        }).flow('drop')
      }
    },
    methods:{
       Acceptpaymentdue(){
         this.$bus.$emit('close-modal', 'sbecompliancemodal') 
         this.sbeflag = 'True'
         this.$store.commit('account/setsbeCompliance','True')
        }, 
       Deniedpaymentdue(){
        this.$bus.$emit('close-modal', 'sbecompliancemodal') 
         this.sbeflag = 'False'
         this.$store.commit('account/setsbeCompliance','False')
       } 
      },
       mounted(){ 
       if(this.currentCountryCode === 'US' || this.currentCountryCode === 'CA' || this.currentCountryCode === 'PL' ){
        this.sbeCompliance = 'NA'
      }
      if(this.currentCountryCode === 'AT' || this.currentCountryCode === 'IT' || this.currentCountryCode === 'BE' || this.currentCountryCode === 'ES'  ){
        this.sbeCompliance = 'True'
      }
      
          this.$bus.$emit('open-modal', 'sbecompliancemodal')
       
    }   
  }
</script>

<style lang="scss">
  .SubscriptionPaymentDetail {
    &_body {
      margin-top: .5rem;
    }

    .PaymentMethod {
      &_wrapper {
        background: rgb(255 255 251);
        margin-bottom: -.3rem;
      }
    }

    .demo {
      width: 40%;
    }

    .adyen-checkout__card__cardNumber__input {
      width: 100%;
    }

    .adyen-checkout__field--expiryDate {
      width: 48%;
    }

    .adyen-checkout__field__cvc {
      width: 48%;
    }

    .adyen-checkout__card__holderName {
      width: 100%;
    }

    .sbeTC {
      font-weight: 700;

      ul {
        margin: 0.1rem 0.2rem 0.2rem 0.2rem;
      }

      ul li {
        display: block;
        height: 15px;
      }
    }

    .modal-button-wrapper {
      display: flex;
      overflow: hidden;
    }

    .AppButton {
      margin: 0 auto;
      width: 2rem;
      min-width: 2rem;
    }

    .newFlowForCancelReplenishment_popUp {
      .modal-title {
        margin: 0.2rem 0;
        text-align: center;
      }
    }

    .v--modal-box {
      .closeButton {
        display: none;
      }
    }
  }
</style>
